import React, { SetStateAction } from "react";
import { WebStoreSelectorType } from "../../../controller/MasterController";
import LogController from "../../../controller/LogController";
import { langText } from "../../../recoil/lang";
import styled from "styled-components";

interface CheckInSliderProps {
  storeList: WebStoreSelectorType | undefined;
  lang: number;
  setVisibleCouponListModal: React.Dispatch<SetStateAction<boolean>>;
}

export const CouponSlider = ({
  storeList,
  lang,
  setVisibleCouponListModal,
}: CheckInSliderProps) => {
  const openEvent = () => {
    if (storeList && storeList.coupon_section.length > 0) {
      LogController.click({
        path: "StoreSelector(MainPage)",
        params: "event",
        params2: "이벤트 쿠폰 클릭",
      });

      setVisibleCouponListModal(true);
    }
  };

  return (
    <Style>
      <div className="slideBadge event" onClick={openEvent}>
        <div className="row gap">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_slide_event.svg`}
            alt="event"
          />
          <h3>EVENT</h3>
        </div>
        <div className="row between">
          <h3>{langText.slider_checkin_coupon[lang]}</h3>
          {/* <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_arrow_right.svg`}
            alt="open"
          /> */}
          <div className="badge">
            <h5>{langText.slider_check[lang]}</h5>
          </div>
        </div>
      </div>
    </Style>
  );
};

const Style = styled.div`
  .slideBadge {
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 5%;
    padding: 10px 18px 10px 30px;

    .row.gap {
      gap: 14px;
    }
    .row.between {
      width: 100%;
      justify-content: space-between;
    }
    h3 {
      padding-top: 4px;
      font-size: 18px;
      line-height: 26px;
      font-weight: 400;
      color: #fff;
      font-family: "Jalnan2TTF";
    }
    .badge {
      border-radius: 7px;
      border: 2px solid #fff;
      padding: 6px 12px;
      h5 {
        font-size: 14px;
        line-height: 20px;
        font-family: "Jalnan2TTF";
        white-space: nowrap;
      }
    }
  }
  .event {
    background: #46ae31;
  }
`;
